import React from 'react';
import { getWorkingTime } from 'features/store-common-info/store-schedule/utils';
import { useModalParameter } from 'features/store-common-info/hooks';
import { contentWrap } from './styles';
import { OperationalTimeButton } from './operational-time-button';
import { StoreModalContent } from './store-modal-content';
import { ModalContentType } from './types';
import {
  BUILDING_YARD_MODAL_LINK_PARAMETER,
  buildingYardButtonImgSrc,
  buildingYardModalImgSrc,
  buildingYardString,
  DATA_QA_STORE_GC_BY,
  GARDEN_CENTER_MODAL_LINK_PARAMETER,
  gardenCenterButtonImgSrc,
  gardenCenterModalImgSrc,
  gardenCenterString,
} from './constants';
import { byContent, gcContent } from './data';

export type StoreGardenCenterBuildingYardProps = {
  gardenCenterOperationalTime?: string;
  buildingYardOperationalTime?: string;
  gaName: string;
};

export const StoreGardenCenterBuildingYard: React.FC<StoreGardenCenterBuildingYardProps> = ({
  gardenCenterOperationalTime,
  buildingYardOperationalTime,
  gaName,
}) => {
  const gardenWorkingTime = getWorkingTime(gardenCenterOperationalTime ?? '');
  const buildingYardWorkingTime = getWorkingTime(buildingYardOperationalTime ?? '');
  const [shouldShowGC, removeGCParameter] = useModalParameter(GARDEN_CENTER_MODAL_LINK_PARAMETER);
  const [shouldShowBY, removeBYParameter] = useModalParameter(BUILDING_YARD_MODAL_LINK_PARAMETER);

  const gardenCenterModalContent: ModalContentType = {
    imgSrc: gardenCenterModalImgSrc,
    title: 'Садовые центры Лемана ПРО',
    modalName: gardenCenterString,
    content: <StoreModalContent content={gcContent} />,
    qaName: 'garden-center',
  };

  const buildingYardModalContent: ModalContentType = {
    imgSrc: buildingYardModalImgSrc,
    title: 'Строительные центры Лемана ПРО',
    modalName: buildingYardString,
    content: <StoreModalContent content={byContent} />,
    qaName: 'building-yard',
  };

  return (
    <div className={contentWrap} data-qa={DATA_QA_STORE_GC_BY}>
      {gardenCenterOperationalTime && (
        <OperationalTimeButton
          preOpened={shouldShowGC}
          modalCloseCb={removeGCParameter}
          imgSrc={gardenCenterButtonImgSrc}
          buttonName={gardenCenterString}
          operationalTime={gardenWorkingTime}
          title="Садовый центр"
          modalContent={gardenCenterModalContent}
          gaName={gaName}
        />
      )}
      {buildingYardOperationalTime && (
        <OperationalTimeButton
          preOpened={shouldShowBY}
          modalCloseCb={removeBYParameter}
          imgSrc={buildingYardButtonImgSrc}
          buttonName={buildingYardString}
          operationalTime={buildingYardWorkingTime}
          title="Строительный центр"
          modalContent={buildingYardModalContent}
          gaName={gaName}
        />
      )}
    </div>
  );
};
